import { TimeBox } from '@cart-ui/TimeBox/TimeBox'
import { Container } from '@pets-ui/Container/Container'
import { HStack } from '@pets-ui/HStack/HStack'
import { Fire } from '@pets-ui/icons'
import { Paper } from '@pets-ui/Paper/Paper'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { zIndex } from '@pets-ui/tokens/zIndex.stylex'
import * as stylex from '@stylexjs/stylex'
import { differenceInDays, differenceInHours, differenceInMinutes, differenceInSeconds } from 'date-fns'
import { useEffect, useState } from 'react'

const styles = stylex.create({
  root: {
    position: 'sticky',
    zIndex: zIndex.fab,
    top: 56,
  },
  title: {
    backgroundColor: colors.red600,
    clipPath: 'polygon(0 0, 100% 0, 100% 0%, 90% 100%, 0 100%)',
  },
})

const defaultTimeLeft: {
  days: number
  hours: number
  minutes: number
  seconds: number
} = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
}

export interface CountdownProgressBarProps {
  endTime: string
}

export const CountdownProgressBar = (props: CountdownProgressBarProps) => {
  const { endTime } = props
  const [timeLeft, setTimeLeft] = useState(defaultTimeLeft)

  useEffect(() => {
    if (!endTime) return
    const endTimeDate = new Date(endTime)
    const timer = setInterval(() => {
      const now = new Date()
      if (now >= endTimeDate) {
        setTimeLeft(defaultTimeLeft)
        clearInterval(timer)
        return
      }
      setTimeLeft({
        days: differenceInDays(endTimeDate, now),
        hours: differenceInHours(endTimeDate, now) % 24,
        minutes: differenceInMinutes(endTimeDate, now) % 60,
        seconds: differenceInSeconds(endTimeDate, now) % 60,
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [endTime])

  return (
    <Paper rootStyle={styles.root} elevation={0} height={32} display="flex" alignItems="center" backgroundColor={colors.black} borderRadius={0}>
      <Container>
        <HStack gap={1} alignItems="center">
          <HStack gap={1} alignItems="center" rootStyle={styles.title} height={32} pl={2} pr={4}>
            <Fire />
            <Text fontWeight="bold" color="white">限時賣場</Text>
          </HStack>
          <HStack gap={1} alignItems="center">
            <Text color="white">{`倒數 ${timeLeft?.days} 天`}</Text>
            <TimeBox backgroundColor={colors.white}>
              <Text color="black" variant="caption">{timeLeft?.hours}</Text>
            </TimeBox>
            <Text color="white">:</Text>
            <TimeBox backgroundColor={colors.white}>
              <Text color="black" variant="caption">{timeLeft?.minutes}</Text>
            </TimeBox>
            <Text color="white">:</Text>
            <TimeBox backgroundColor={colors.white}>
              <Text color="black" variant="caption">{timeLeft?.seconds}</Text>
            </TimeBox>
          </HStack>
        </HStack>
      </Container>
    </Paper>
  )
}
